import 'jquery-validation';
import Utils from '../../util/utils';
const ContactForm = {

    _jForm: $('.jsContactForm'),
    email: '',
    init() {
        this.initValidations();
        jQuery.validator.addMethod('onlynumber', function(value, element) {
            return this.optional(element) || /^-?\d*$/i.test(value);
        }, 'Please provide only number.');
    },
    initValidations() {
        const me = this;
        if (this._jForm.length > 0) {
            var config = Utils.getValidationConfig({
                ignore: [],
                rules: {
                    your_name: {
                        required: true,
                        minlength: 2,
                    },
                    your_phone: {
                        required: true,
                        onlynumber : true,
                        minlength: 8,
                        maxlength:10,
                    },
                    your_email: {
                        required: true,
                        customemail: true,
                    },

                    your_subject: {
                        required: true,
                    },
                    your_message: {
                        required: true,
                        minlength: 10,
                    },
                },
                messages: {
                    your_name: {
                        required: 'Please provide your name',
                        minlength: 'Please provide your complete Name',
                    },
                    your_phone: {
                        required: 'Please provide your phone',
                        minlength: 'Please provide minimum 8 digit number',
                        maxlength: 'Please provide maximum 10 digit number',
                        //onlynumber : 'Please provide only number',
                    },
                    your_email: {
                        required: 'Please provide your e-mail address',
                        customemail: 'Please provide a valid e-mail address',
                    },
                    your_subject: {
                        required: 'Please provide your subject',
                    },
                    your_message: {
                        required: 'Please provide your message',
                        minlength: 'Please write at least 10 characters',
                    },
                },
                submitHandler: function() {

                    me.onFormSubmit();

                },
            });
            this._jForm.validate(config);
        }
    },
    onFormSubmit() {
      if (this._jForm.valid()) {
          var $form = this._jForm;
          var unindexed_array = $form.serializeArray();
          var indexed_array = {};
          jQuery.map(unindexed_array, function(n) {
              indexed_array[n['name']] = n['value'];
          });
          var formData = {};
          formData = indexed_array;
          formData.form_type = 'plans_from';
          Utils.sendRequest({
              'url': '/wp-admin/admin-ajax.php',
              'data': {
                  'action': 'getContactForm',
                  'formData': formData,
              },
              'onDone': $.proxy(this._onSuccess, this),
          });
      }
      return false;
  },
  _onSuccess(response) {

        this._jForm[0].reset();
        Utils.showLoader(true);
        if(response.status == 'mail_sent'){
            window.location.replace('/thank-you/');
        }else{
            Utils.notify({'message': response.message});
        }
    },
}
export default ContactForm;



// WEBPACK FOOTER //
// ./scripts/modules/forms/contact_form.js